import { StyleSheet } from 'react-native'

import { MotiView } from '@zet/common/components/motiView'
import { XStack, colors } from '@zet/design-system'
import { Skeleton } from 'moti/skeleton'

import { Spacer } from './spacer'

const CategoryLoader = () => {
  return Array.from({ length: 6 }).map((_, index) => (
    <XStack key={index}>
      <MotiView
        transition={{
          type: 'timing',
        }}
        style={[styles.container, styles.padded]}
        animate={{ backgroundColor: colors.neutral.white100 }}
      >
        <Skeleton colorMode={'light'} width={'100%'} height={100} />
        <Spacer height={8} />
        <Skeleton colorMode={'light'} width={'100%'} height={20} />
        <Spacer height={8} />
        <Skeleton colorMode={'light'} width={'100%'} height={12} />
      </MotiView>
      <MotiView
        transition={{
          type: 'timing',
        }}
        style={[styles.container, styles.padded]}
        animate={{ backgroundColor: colors.neutral.white100 }}
      >
        <Skeleton colorMode={'light'} width={'100%'} height={100} />
        <Spacer height={8} />
        <Skeleton colorMode={'light'} width={'100%'} height={20} />
        <Spacer height={8} />
        <Skeleton colorMode={'light'} width={'100%'} height={12} />
      </MotiView>
    </XStack>
  ))
}

export default CategoryLoader

const styles = StyleSheet.create({
  shape: {
    height: 250,
    width: 250,
    borderRadius: 25,
    marginRight: 10,
    backgroundColor: 'white',
  },
  container: {
    flex: 1,
  },
  padded: {
    padding: 16,
  },
})
